@if (!connectivity.isOnline()) {
  <div class="offline-banner" role="alert">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9v4M12 17h.01"/><circle cx="12" cy="12" r="9"/></svg>
    <span>{{ 'offline.message' | translate }}</span>
  </div>
}
